// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-date {
  font-size: 14px;
  color: #909092; }

.event-row {
  font-size: 18px; }

.event-row:hover {
  opacity: .7;
  cursor: pointer; }

.event-row-container {
  display: flex;
  justify-content: space-between; }
`, "",{"version":3,"sources":["webpack://./src/components/Events/event.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,WAAW;EACX,eAAe,EAAE;;AAEnB;EACE,aAAa;EACb,8BAA8B,EAAE","sourcesContent":[".event-date {\n  font-size: 14px;\n  color: #909092; }\n\n.event-row {\n  font-size: 18px; }\n\n.event-row:hover {\n  opacity: .7;\n  cursor: pointer; }\n\n.event-row-container {\n  display: flex;\n  justify-content: space-between; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
